import { render, staticRenderFns } from "./MonitoringIndex.vue?vue&type=template&id=37bae09e&"
import script from "./MonitoringIndex.vue?vue&type=script&lang=js&"
export * from "./MonitoringIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports